'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useGetProfileInfoQuery } from '@akinon/next/data/client/account';
import { useGetWalletQuery } from '@theme/rtk/wallet';
import { useSession } from 'next-auth/react';

export const WalletPrefetch = () => {
  const pathname = usePathname();
  const { status } = useSession();

  const { data: profileInfo } = useGetProfileInfoQuery(undefined, {
    skip: status !== 'authenticated'
  });

  const customerId = profileInfo?.attributes?.customer_id;

  const { refetch } = useGetWalletQuery(
    {
      customer_id: customerId,
      user_email: profileInfo?.email
    },
    {
      skip: !customerId
    }
  );

  useEffect(() => {
    if (!customerId) return;
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, customerId]);

  return null;
};
